module.exports = __webpack_public_path__ + "img/2_240.510fb06c.png";